import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { Enum3alwj03lh1n41 as Enum } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Enum.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var static_init_called;
function static_init() {
  if (static_init_called)
    return Unit_instance;
  static_init_called = true;
  PinTarget_Pair_instance = new (PinTarget())('Pair', 0);
}
var PinTarget_Pair_instance;
var PinTargetClass;
function PinTarget() {
  if (PinTargetClass === VOID) {
    class $ extends Enum() {}
    initMetadataForClass($, 'PinTarget');
    PinTargetClass = $;
  }
  return PinTargetClass;
}
function PinTarget_Pair_getInstance() {
  static_init();
  return PinTarget_Pair_instance;
}
//region block: exports
export {
  PinTarget_Pair_getInstance as PinTarget_Pair_getInstancec1tshbk9zqjw,
};
//endregion

//# sourceMappingURL=PinTarget.mjs.map
